import * as React from 'react'
import * as styles from '../style/index.scss'
import intl from '@utils/intl';
import { FormattedMessage } from 'react-intl'
import { filterFlowUnit, formatDate } from '@src/utils';
import VeritcalLineTitle from '@componentsG/veritcalLineTitle'

export default ({ currentPackageInfo, expansionDetail }) => (
    <div className={styles.expansionPackageInfoWrap}>
        <VeritcalLineTitle messageId="packageDetail.expansionPackage.title" />
        <section className={styles.expansionInnerWrap}>
            <div className={styles.currentPackageWrap}>
                <p>{filterFlowUnit(currentPackageInfo.policyDegree)}</p>
                <span>{`${formatDate(currentPackageInfo.startDate)} - ${formatDate(currentPackageInfo.endDate)} UTC`}</span>
            </div>
            <div className={styles.addPackageWrap}>
                <p>{intl.formatMessage({ id: 'package.expand.add' })} {filterFlowUnit(expansionDetail.policyDegree)}</p>
                <span>
                    <FormattedMessage
                        id="package.validTo"
                        values={{
                            date: formatDate(expansionDetail.validTime || {})
                        }}
                    />
                </span>
            </div>
        </section>
    </div>
)
